<template>
  <v-avatar
    :color="backgroundColor"
    :style="'border-radius: 25%; border: ' + borderSize + ' solid #fff !important'"
    :size="size"
  >
    <span :style="style">B</span>
  </v-avatar>
</template>

<script>
export default {
  props: {
    size: {
      type: Number,
      default: 42,
    },
    backgroundColor: {
      type: String,
      default: "#9C27B0",
    },
    dark: {
      type: Boolean,
      default: false,
    },
    light: {
      type: Boolean,
      default: false,
    },
  },

  computed: {
    style() {
      const styles = [
        "text-shadow:" + this.textShadow,
        "font-size:" + this.fontSize,
        "background-color:" + this.backgroundColorRgb,
        "color:" + this.color,
      ];
      return styles.join(";") + ";text-align:center;display:inline-block;";
    },
    fontSize() {
      const size = (this.size * 34) / 42;
      return Math.round(size) + "px";
    },
    borderSize() {
      const size = (this.size * 2) / 42;
      return Math.round(size) + "px";
    },
    backgroundColorRgb() {
      return hexToRgbString(this.backgroundColor);
    },
    textShadow() {
      return makeTextShadow(this.backgroundColorRgb, 15, 5, 2, 5);
    },
    color() {
      if (this.light) return "#000";
      return "#fff";
    },
  },
};

function makeTextShadow(rgbColorString, elCount, addR = 2.6, addG = 0.67, addB = 2.94) {
  const rgb = getColorValues(rgbColorString);
  let r = rgb[0];
  let g = rgb[1];
  let b = rgb[2];
  let colors = [];
  for (let i = elCount; i >= 0; i--) {
    r = r - addR;
    g = g - addG;
    b = b - addB;
    colors[i] =
      "rgb(" +
      Math.round(r) +
      "," +
      Math.round(g) +
      "," +
      Math.round(b) +
      ") " +
      i +
      "px " +
      i +
      "px " +
      "0" +
      "px" +
      (i === elCount ? "" : ",");
  }

  return colors.join("");
}

function getColorValues(rgbString) {
  return rgbString
    .replace("rgb(", "")
    .replace(")", "")
    .replace(" ", "")
    .split(",")
    .map(number => parseInt(number));
}

function hexToRgb(hex) {
  // Expand shorthand form (e.g. "03F") to full form (e.g. "0033FF")
  var shorthandRegex = /^#?([a-f\d])([a-f\d])([a-f\d])$/i;
  hex = hex.replace(shorthandRegex, function(m, r, g, b) {
    return r + r + g + g + b + b;
  });

  var result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
  return result
    ? {
        r: parseInt(result[1], 16),
        g: parseInt(result[2], 16),
        b: parseInt(result[3], 16),
      }
    : null;
}

function hexToRgbString(hex) {
  const x = hexToRgb(hex);
  return "rgb(" + x.r + "," + x.g + "," + x.b + ")";
}
</script>
